module.exports = __webpack_public_path__ + "img/checkmark-done-green.a881e487.svg";